import { ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { ApiService } from '../../../services/api.service';
import { TemplateService } from '../../../services/template.service';
import { HttpParams } from '@angular/common/http';
import { CONSTANT, SUPPORT_FORMAT } from '../../../services/constant';
import { API_CONSTANT } from '../../../services/api.constant';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
var DocumentUploadComponent = (function () {
    function DocumentUploadComponent(apiService, modalService, template, router, translate) {
        this.apiService = apiService;
        this.modalService = modalService;
        this.template = template;
        this.router = router;
        this.translate = translate;
        this.objectValues = function (obj) {
            // Object.values is not supported in IE11
            if (typeof obj === 'string' || obj instanceof String) {
                return obj.split('\n');
            }
            else {
                return Object.keys(obj).map(function (e) { return obj[e]; });
            }
        };
        this.step = 0;
        this.isLoading = false;
        this.event_name = '';
        this.fileList = [];
        this.fileDocList = [];
        this.fileData = [];
        this.list = [];
        this.loading_excel_report = false;
        this.gettingSummary = false;
        this.upload_status_message = '';
        this.resultCurrentPage = 1;
        this.uploadCSVStatusIntervalHandler = null;
        this.taxDataResultCount = 0;
        this.taxDataResultItemPerPage = 40;
        this.tax_import_id = 0;
        this.loading_all_zip = false;
        this.cancel_loading_all_zip = false;
        this.loading_all_zip_message = '';
        this.allZipCurrent = 0;
        this.loading_all_zip_progress = 0;
        this.errorMsgForShow = null;
        this.Namebottomback = '';
        this.Namebottomtampate = '';
        this.items = [
            { label: 'เลือกประเภทเอกสาร' },
            { label: 'อัพโหลดไฟล์ CSV' },
            { label: 'สร้างไฟล์' },
            { label: 'ผลลัพธ์' }
        ];
        this.encodingType = CONSTANT.encodingType;
        this.encodingSelected = 'UTF-8';
        this.gettingUploadCSVStatus = false;
    }
    DocumentUploadComponent.prototype.ngOnInit = function () {
    };
    DocumentUploadComponent.prototype.ngOnDestroy = function () {
        if (this.uploadCSVStatusIntervalHandler != null)
            clearInterval(this.uploadCSVStatusIntervalHandler);
        this.uploadCSVStatusIntervalHandler = null;
    };
    Object.defineProperty(DocumentUploadComponent.prototype, "supportFormat", {
        get: function () {
            return SUPPORT_FORMAT.join();
        },
        enumerable: true,
        configurable: true
    });
    DocumentUploadComponent.prototype.incomingFile = function (event) {
        var files = _.get(event, 'target.files', [this.file]);
        this.file = _.get(event, 'target.files[0]', this.file);
        var fileSize = this.file.size;
        // show error msg if csv file size is more than 3 MB
        if (fileSize > 3145728) {
            this.step = 3;
            this.error_message = this.translate.instant('ERROR.MORE-THAN-3MB');
            return;
        }
        this.getSummary();
    };
    DocumentUploadComponent.prototype.selectEncoding = function () {
        if (this.file) {
            this.incomingFile();
        }
    };
    DocumentUploadComponent.prototype.nextStep = function (step) {
        // make this.file = null again because don't use remove file function
        this.file = null;
        this.errorExcelPath = null;
        this.errorExcelName = null;
        this.step = step;
    };
    DocumentUploadComponent.prototype.getSummary = function () {
        var _this = this;
        var document = new FormData();
        document.append('file', this.file);
        document.append('file_type', this.selectedDocumentType);
        document.append('decode_type', (this.encodingSelected === 'UTF-8') ? 'utf-8' : 'CP874');
        this.gettingSummary = true;
        this.apiService.postSummary(document).subscribe(function (res) {
            _this.totalDocument = res.total_document;
            _this.totalPayment = res.total_payment;
            _this.totalVat = res.vat;
            _this.step = 2;
            _this.gettingSummary = false;
        }, function (err) {
            _this.error_message = err.error.result;
            _this.errorExcelPath = err.error.error_file_path;
            _this.errorExcelName = err.error.error_file_name;
            _this.step = 3;
            _this.gettingSummary = false;
        });
    };
    DocumentUploadComponent.prototype.selectDocumentType = function (type) {
        this.selectedDocumentType = type;
        this.step = 1;
    };
    DocumentUploadComponent.prototype.generateXML = function () {
        var _this = this;
        this.isLoading = true;
        var document = new FormData();
        document.append('rd_document_type', this.selectedDocumentType);
        document.append('csv_file', this.file);
        document.append('decode_type', (this.encodingSelected === 'UTF-8') ? 'utf-8' : 'CP874');
        this.error_message = null;
        this.apiService.uploadCSV(document).subscribe(function (data) {
            data = data || {};
            var background_job_id = data['background_job_id'];
            _this.tax_import_id = data['id'];
            _this.upload_status_message = '0 %';
            _this.gettingUploadCSVStatus = false;
            if (_this.uploadCSVStatusIntervalHandler != null)
                clearInterval(_this.uploadCSVStatusIntervalHandler);
            _this.uploadCSVStatusIntervalHandler = setInterval(function () {
                _this.refreshUploadCSVStatus(background_job_id);
            }, 5000);
        }, function (error) {
            _this.error_message = _this.translate.instant('ERROR.TRY-AGAIN');
            _this.isLoading = false;
            _this.step = 3;
        });
    };
    DocumentUploadComponent.prototype.refreshUploadCSVStatus = function (background_job_id) {
        var _this = this;
        if (this.gettingUploadCSVStatus) {
            return;
        }
        this.gettingUploadCSVStatus = true;
        this.apiService.getBackgroundJobStatus(background_job_id).subscribe(function (data) {
            data = data || {};
            var status = data['status'];
            var progress = data['progress'] || 0;
            _this.upload_status_message = '' + progress + ' %';
            if (status === 'success') {
                clearInterval(_this.uploadCSVStatusIntervalHandler);
                _this.uploadCSVStatusIntervalHandler = null;
                _this.upload_status_message = 'กำลังแสดงผลลัพธ์ ...';
                _this.resultCurrentPage = 1;
                _this.showUploadCSVResult();
            }
            else if (status === 'failed') {
                clearInterval(_this.uploadCSVStatusIntervalHandler);
                _this.uploadCSVStatusIntervalHandler = null;
                _this.error_message = data['result']['result'];
                if (_this.error_message != null && _this.error_message.message != null) {
                    _this.error_message = _this.error_message.message;
                }
                else if (!_this.isFieldError(_this.error_message)) {
                    _this.error_message = JSON.stringify(_this.error_message);
                }
                _this.errorExcelPath = data['result']['error_file_path'];
                _this.errorExcelName = data['result']['error_file_name'];
                _this.isLoading = false;
                _this.step = 3;
            }
            _this.gettingUploadCSVStatus = false;
        }, function (error) {
            _this.gettingUploadCSVStatus = false;
        });
    };
    DocumentUploadComponent.prototype.showUploadCSVResult = function () {
        var _this = this;
        var params = new HttpParams().set('page', _.toString(this.resultCurrentPage));
        var data = {
            'tax_import_id': this.tax_import_id
        };
        this.apiService.getTaxDataResult(data, params).subscribe(function (data) {
            data = data || {};
            _this.taxDataResultCount = data.count;
            _this.list = data.results;
            _this.isLoading = false;
            _this.step = 3;
            var type = _this.selectedDocumentType;
            var target = _this.list.map(function (obj) { return (obj.header_invoice_number + ' ' + obj.seller_tax_id); }).join(', ');
            _this.sniff('CREATE_FILE', type + ', ' + target);
        }, function (error) {
            _this.error_message = 'ข้อมูลได้นำเข้าสู่ระบบเรียบร้อยแล้ว ท่านสามารถดูผลลัพธ์ได้ที่เมนูค้นหาเอกสาร';
            _this.isLoading = false;
            _this.step = 3;
        });
    };
    DocumentUploadComponent.prototype.resetAll = function () {
        // location.replace('/document/upload');
        this.step = 0;
        this.file = null;
        this.error_message = null;
        this.isLoading = false;
        this.selectedDocumentType = null;
        this.event_name = '';
        this.fileList = [];
        this.fileData = [];
        this.isXMLDownloaded = null;
        this.isPDFDownloaded = null;
        this.list = [];
        this.totalDocument = 0;
        this.totalPayment = 0;
        this.totalVat = 0;
        this.date = null;
        this.errorExcelName = null;
        this.errorExcelPath = null;
    };
    DocumentUploadComponent.prototype.resetSignDoc = function () {
        this.fileDocList = [];
        this.error_message = null;
        this.isLoading = false;
        this.signDocResultPath = null;
    };
    DocumentUploadComponent.prototype.downloadFile = function (tax_data, type) {
        var _this = this;
        this.apiService.getFileFullPath(API_CONSTANT.BASE_URL + (type === 'xml' ? tax_data.xml_file : tax_data.pdf_file)).subscribe(function (obj) {
            var filename = _this.getFileName(tax_data.header_invoice_number) +
                '_' + tax_data.rd_document_type + '_' + tax_data.header_issue_dt + '.' + type;
            _this.apiService.createDownloadFile(obj, filename);
            if (type === 'xml') {
                _this.sniff('DOWNLOAD_XML', filename);
            }
            else {
                _this.sniff('DOWNLOAD_PDF', filename);
            }
        }, function (error) {
        });
    };
    DocumentUploadComponent.prototype.downloadExcel = function (errorExcel) {
        var _this = this;
        this.loading_excel_report = true;
        this.apiService.getFileFullPath(API_CONSTANT.BASE_URL + errorExcel).subscribe(function (obj) {
            _this.apiService.createDownloadFile(obj, _this.errorExcelName);
            _this.sniff('DOWNLOAD_XLS', _this.errorExcelName);
            _this.loading_excel_report = false;
        }, function (error) {
            _this.loading_excel_report = false;
        });
    };
    DocumentUploadComponent.prototype.download = function (type, page_number, page_all_count, index, data_list) {
        var _this = this;
        this.loading_all_zip = true;
        if (index >= data_list.length && page_number > page_all_count) {
            this.loading_all_zip = false;
            this.loading_all_zip_message = this.translate.instant('TEXT.DOWNLOAD-COMPLETE') + ' ' + '(' +
                this.translate.instant('FILTER.ALL') + ' ' + this.allZipCount + ' ' +
                this.translate.instant('COMMON.ITEMS') + ')';
            return;
        }
        if (this.cancel_loading_all_zip) {
            return;
        }
        var tax_data = data_list[index];
        this.apiService.getFileFullPath(API_CONSTANT.BASE_URL + (type === 'xml' ? tax_data.xml_file : tax_data.pdf_file)).subscribe(function (obj) {
            if (_this.cancel_loading_all_zip) {
                return;
            }
            var filename = _this.getFileName(tax_data.header_invoice_number) +
                '_' + tax_data.rd_document_type + '_' + tax_data.header_issue_dt + '.' + type;
            _this.apiService.createDownloadFile(obj, filename);
            _this.allZipCurrent++;
            _this.loading_all_zip_progress = (_this.allZipCurrent / _this.allZipCount) * 100;
            setTimeout(function () {
                if (index + 1 < data_list.length)
                    _this.download(type, page_number, page_all_count, index + 1, data_list);
                else if (page_number < page_all_count) {
                    page_number += 1;
                    _this.apiService.getTaxDataResult({ 'tax_import_id': _this.tax_import_id }, new HttpParams().set('page', '' + page_number)).subscribe(function (data) {
                        data = data || {};
                        _this.download(type, page_number, page_all_count, 0, data.results);
                    }, function (error) {
                        _this.loading_all_zip = false;
                        _this.loading_all_zip_message = _this.translate.instant('ERROR.TRY-AGAIN');
                    });
                }
                else {
                    _this.download(type, page_number + 1, page_all_count, 0, []);
                }
            }, 1000);
        }, function (error) {
            _this.loading_all_zip = false;
            _this.loading_all_zip_message = _this.translate.instant('ERROR.TRY-AGAIN');
        });
    };
    DocumentUploadComponent.prototype.downloadAll = function (type, content) {
        var _this = this;
        this.apiService.getTaxDataResult({ 'tax_import_id': this.tax_import_id }, new HttpParams().set('page', '1')).subscribe(function (data) {
            data = data || {};
            _this.modal = _this.modalService.open(content, { backdrop: 'static', keyboard: false, centered: true });
            _this.allZipCount = data.count;
            _this.cancel_loading_all_zip = false;
            _this.download(type, 1, Math.ceil(data.count / 40), 0, data.results);
        }, function (error) {
        });
        if (type === 'xml') {
            this.sniff('DOWNLOAD_ALL_XML', '');
        }
        else {
            this.sniff('DOWNLOAD_ALL_PDF', '');
        }
    };
    DocumentUploadComponent.prototype.closeDownloadAll = function () {
        this.modal.close();
        this.cancel_loading_all_zip = true;
        this.loading_all_zip = false;
        this.allZipCurrent = 0;
        this.loading_all_zip_progress = 0;
    };
    DocumentUploadComponent.prototype.generateDoc = function () {
        var _this = this;
        this.isLoading = true;
        this.error_message = null;
        var form = new FormData();
        for (var _i = 0, _a = this.fileDocList; _i < _a.length; _i++) {
            var file = _a[_i];
            form.append('file', file);
        }
        this.apiService.signSignature(form).subscribe(function (blob) {
            _this.signDocResultPath = blob;
            _this.isLoading = false;
        }, function (error) {
            _this.error_message = _this.checkErrorMsg(error);
            _this.isLoading = false;
        });
    };
    DocumentUploadComponent.prototype.checkErrorMsg = function (error) {
        this.errorMsgForShow = this.apiService.getErrorMessage(error);
        if (this.translate.currentLang === 'en') {
            this.error_message = this.errorMsgForShow[0];
        }
        else {
            this.error_message = this.errorMsgForShow[1];
        }
    };
    DocumentUploadComponent.prototype.downloadSignedDoc = function () {
        var filename = '';
        if (this.fileDocList.length === 1) {
            var filenameSplit = this.fileDocList[0].name.split('.');
            var extension = filenameSplit.pop();
            filename = filenameSplit.join('.') + '_signed.' + extension;
        }
        else {
            filename = 'documents_signed.zip';
        }
        this.apiService.createDownloadFile(this.signDocResultPath, filename);
    };
    DocumentUploadComponent.prototype.removeDocFile = function (index) {
        this.fileDocList.splice(index, 1);
        if (this.fileDocList.length === 0) {
            this.resetSignDoc();
        }
    };
    DocumentUploadComponent.prototype.getFileName = function (invoice_number) {
        return invoice_number.replace(/[^-\w.ก-๙]+/g, '_');
    };
    DocumentUploadComponent.prototype.isFieldError = function (errors) {
        return errors != null && errors.length > 0 && errors[0].row;
    };
    DocumentUploadComponent.prototype.getNamebottomback = function () {
        if (this.translate.currentLang === 'en') {
            this.Namebottomback = 'Back';
        }
        if (this.translate.currentLang === 'th') {
            this.Namebottomback = 'กลับ';
        }
        return this.Namebottomback;
    };
    DocumentUploadComponent.prototype.getNamebottomtemplate = function () {
        if (this.translate.currentLang === 'en') {
            this.Namebottomtampate = 'Create new file';
        }
        if (this.translate.currentLang === 'th') {
            this.Namebottomtampate = 'สร้างเอกสารใหม่';
        }
        return this.Namebottomtampate;
    };
    DocumentUploadComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'DOC_UPLOAD',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    return DocumentUploadComponent;
}());
export { DocumentUploadComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-upload/document-upload.component.ts.pre-build-optimizer.js